import React from 'react'
import PaintContainer from './PaintContainer'

const Interior = props => (
  <PaintContainer data-test="component-configurator-design-interior" {...props} />
)

export default Interior
